import { CRUISE_PHONE_DISPLAY, FLIGHT_PHONE_DISPLAY, MAIN_PHONE_DISPLAY } from './contact';
import { SITE_DOMAIN, SITE_NAME, SITE_URL } from './site';

const CRUISE_BASE = `${SITE_URL.replace(/\/$/, '')}/cruises`;
const FLIGHT_BASE = `${SITE_URL.replace(/\/$/, '')}/flight`;

export const DEFAULT_PAGE_META = {
  title: `${SITE_NAME} | Flights, Hotels & Travel Packages | ${SITE_DOMAIN}`,
  description: `${SITE_NAME} is an all-in-one travel agency operated by Nodex Global LLC. Book flights, hotels and vacation packages, or call ${MAIN_PHONE_DISPLAY} 24/7.`,
  url: SITE_URL,
  themeColor: '#0b5cad',
};

export const CRUISE_PAGE_META = {
  title: `${SITE_NAME} | Book Affordable Cruises Online | ${SITE_DOMAIN}`,
  description: `Book affordable cruises with ${SITE_NAME}. Search Caribbean, Mediterranean, Alaska, and more. Call cruise experts 24/7 at ${CRUISE_PHONE_DISPLAY}.`,
  url: `${CRUISE_BASE}`,
  themeColor: '#059669',
};

export const CRUISE_SEARCH_META = {
  title: `Cruise Search Results | ${SITE_NAME} | ${SITE_DOMAIN}`,
  description: `Compare cruise sailings by port, region, and dates. ${SITE_NAME} cruise concierge — call ${CRUISE_PHONE_DISPLAY} for unpublished fares and cabin options.`,
  url: `${CRUISE_BASE}/search`,
  themeColor: '#059669',
};

export const FLIGHT_PAGE_META = {
  title: `${SITE_NAME} | Call our Flight Booking Experts — Save up to 30% | ${SITE_DOMAIN}`,
  description: `Book affordable flights and hotels with ${SITE_NAME}. Search flights, hotels, cars, packages, and cruises. Call ${FLIGHT_PHONE_DISPLAY} for unpublished discounts.`,
  url: FLIGHT_BASE,
  themeColor: '#059669',
};
